import { RowLabelAction } from '../../RowLabelAction';

type MileageOptionsLabelProps = {
    label: string;
    inputId: string;
    hasOptions: boolean;
    isLocked: boolean;
    onOptionsActivate: () => void;
};

export const MileageOptionsLabel = ({ label, inputId, hasOptions, isLocked, onOptionsActivate }: MileageOptionsLabelProps) =>
    hasOptions ? (
        <RowLabelAction onActivate={onOptionsActivate} disabled={isLocked} testId="custom-mileage-options-button">
            {label}
        </RowLabelAction>
    ) : (
        <label htmlFor={inputId} data-testid="custom-mileage-label">
            {label}
        </label>
    );
